import { Component, Input } from '@angular/core';
import { FnolRequest } from "../../../models";

@Component({
  selector: 'CPF-classification-check',
  templateUrl: './classification-check.component.html',
  styleUrls: ['./classification-check.component.scss']
})
export class ClassificationCheckComponent {
  _fnolRequest?: FnolRequest;

  // Flags which checks should be performed
  availableChecks = {
    medicalFood: false,
    complementaryMedicine: false,
    behavioralTreatment: false,
  }

  // Store values of performed checks
  checksPerformed: {
    medicalFoodPrescription?: boolean,
    complementaryMedicinePrescription?: boolean,
    complementaryMedicineTherapist?: boolean,
    behavioralTreatmentTherapist?: boolean,
  } = {
    medicalFoodPrescription: undefined,
    complementaryMedicinePrescription: undefined,
    complementaryMedicineTherapist: undefined,
    behavioralTreatmentTherapist: undefined,
  }

  buttonsColor = {
    medicalFoodYes: '',
    medicalFoodNo: '',
    complementaryMedicinePrescriptionYes: '',
    complementaryMedicinePrescriptionNo: '',
    complementaryMedicineTherapistYes: '',
    complementaryMedicineTherapistNo: '',
    behavioralTreatmentTherapistYes: '',
    behavioralTreatmentTherapistNo: '',
  }

  // Set which checks need to be performed
  @Input() set fnolRequest(value: FnolRequest) {
    this._fnolRequest = value;

    this._fnolRequest.parsedInvoiceData.treatments.forEach(t => t.positions.forEach(p => {
      if (p.classification && p.classification.subtype === 'medizinalfutter') {
        this.availableChecks.medicalFood = true;
      }

      if (p.classification && p.classification.subtype === 'komplementaermedizinische_behandlung') {
        this.availableChecks.complementaryMedicine = true;
      }

      if (p.classification && p.classification.subtype === 'verhaltensmedizinische_behandlung') {
        this.availableChecks.behavioralTreatment = true;
      }

      if (p.classification && p.classification.checks && p.classification.checks.medicalFoodPrescription !== undefined) {
        this.setMedicalFood(p.classification.checks.medicalFoodPrescription, false);
      }

      if (p.classification && p.classification.checks && p.classification.checks.complementaryMedicinePrescription !== undefined) {
        this.setComplementaryMedicinePrescription(p.classification.checks.complementaryMedicinePrescription, false);
      }

      if (p.classification && p.classification.checks && p.classification.checks.complementaryMedicineTherapist !== undefined) {
        this.setComplementaryMedicineTherapist(p.classification.checks.complementaryMedicineTherapist, false);
      }

      if (p.classification && p.classification.checks && p.classification.checks.behavioralTreatmentTherapist !== undefined) {
        this.setBehavioralTreatmentTherapist(p.classification.checks.behavioralTreatmentTherapist, false);
      }
    }))
  }

  constructor() {
  }

  // Set checks back to fnolRequest, function should be called on each button click
  setFnolRequestChecks() {
    if (!this._fnolRequest) {
      return
    }

    this._fnolRequest.parsedInvoiceData.treatments.forEach(t => t.positions.forEach(p => {
      if (p.classification && p.classification.subtype === 'medizinalfutter') {
        p.classification.checks ? p.classification.checks.medicalFoodPrescription = this.checksPerformed.medicalFoodPrescription : p.classification.checks = { medicalFoodPrescription: this.checksPerformed.medicalFoodPrescription };
      }

      if (p.classification && p.classification.subtype === 'komplementaermedizinische_behandlung') {
        p.classification.checks ? p.classification.checks.complementaryMedicinePrescription = this.checksPerformed.complementaryMedicinePrescription : p.classification.checks = { complementaryMedicinePrescription: this.checksPerformed.complementaryMedicinePrescription };
        p.classification.checks ? p.classification.checks.complementaryMedicineTherapist = this.checksPerformed.complementaryMedicineTherapist : p.classification.checks = { complementaryMedicineTherapist: this.checksPerformed.complementaryMedicineTherapist };
      }

      if (p.classification && p.classification.subtype === 'verhaltensmedizinische_behandlung') {
        p.classification.checks ? p.classification.checks.behavioralTreatmentTherapist = this.checksPerformed.behavioralTreatmentTherapist : p.classification.checks = { behavioralTreatmentTherapist: this.checksPerformed.behavioralTreatmentTherapist };
      }
    }))
  }

  setMedicalFood(value: boolean, setFnolRequestChecks = true) {
    this.checksPerformed.medicalFoodPrescription = value;

    if (value) {
      this.buttonsColor.medicalFoodYes = 'primary';
      this.buttonsColor.medicalFoodNo = '';
    } else {
      this.buttonsColor.medicalFoodYes = '';
      this.buttonsColor.medicalFoodNo = 'primary';
    }

    if (setFnolRequestChecks) {
      this.setFnolRequestChecks();
    }
  }

  setComplementaryMedicinePrescription(value: boolean, setFnolRequestChecks = true) {
    this.checksPerformed.complementaryMedicinePrescription = value;

    if (value) {
      this.buttonsColor.complementaryMedicinePrescriptionYes = 'primary';
      this.buttonsColor.complementaryMedicinePrescriptionNo = '';
    } else {
      this.buttonsColor.complementaryMedicinePrescriptionYes = '';
      this.buttonsColor.complementaryMedicinePrescriptionNo = 'primary';
    }

    if (setFnolRequestChecks) {
      this.setFnolRequestChecks();
    }
  }

  setComplementaryMedicineTherapist(value: boolean, setFnolRequestChecks = true) {
    this.checksPerformed.complementaryMedicineTherapist = value;

    if (value) {
      this.buttonsColor.complementaryMedicineTherapistYes = 'primary';
      this.buttonsColor.complementaryMedicineTherapistNo = '';
    } else {
      this.buttonsColor.complementaryMedicineTherapistYes = '';
      this.buttonsColor.complementaryMedicineTherapistNo = 'primary';
    }

    if (setFnolRequestChecks) {
      this.setFnolRequestChecks();
    }
  }

  setBehavioralTreatmentTherapist(value: boolean, setFnolRequestChecks = true) {
    this.checksPerformed.behavioralTreatmentTherapist = value;

    if (value) {
      this.buttonsColor.behavioralTreatmentTherapistYes = 'primary';
      this.buttonsColor.behavioralTreatmentTherapistNo = '';
    } else {
      this.buttonsColor.behavioralTreatmentTherapistYes = '';
      this.buttonsColor.behavioralTreatmentTherapistNo = 'primary';
    }

    if (setFnolRequestChecks) {
      this.setFnolRequestChecks();
    }
  }
}
